import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import SkydataMainMenu from "@/components/skydata/skydata-main-menu";
import SkyDataWeatherMap from "@/components/skydata/weather-map";

const SkyDataMainLayout: React.FC = () => {
  useEffect(() => {
    document.title =
      "ntv" === "ntv" ? "NTV Weather" : "Skydata";
  }, []);
  return (
    <div className="h-screen w-full  flex flex-col ">
      <SkydataMainMenu />
      <SkyDataWeatherMap />
      <Outlet />
    </div>
  );
};

export default SkyDataMainLayout;
